import {
  useEvent,
  useEventsOnViewLoad
} from '@emerald-works/react-event-bus-client'

import React from 'react'
import { useSelector } from 'react-redux'
import { UserListSlice } from '../../../reducers'
import { CONSUMER_GROUPS } from '../../../util/userGroups'
import useConsumerTenant from '../../consumer-list/useConsumerTenant'
import { Select } from '../components'

const filterRoles = rolesList =>
  rolesList
    .filter(x => CONSUMER_GROUPS.includes(x.GroupName))
    .map(x => x.GroupName)

const RoleInput = ({ control }) => {
  const userPoolId = useConsumerTenant()
  const { detail: { username } } = useSelector(UserListSlice.selectors.selectUser)
  const [options, setOptions] = React.useState(CONSUMER_GROUPS)

  const [getUserRoles] = useEvent([
    {
      eventName: 'adminGetUserRoles',
      onSuccess: payload => {
        setOptions(filterRoles(payload.roles.Groups))
      }
    }
  ])

  useEventsOnViewLoad(() => {
    getUserRoles.trigger({ userPoolId, username })
  }, [getUserRoles, userPoolId, username])

  return (
    <Select
      name='role'
      control={control}
      loading={getUserRoles.isWorking}
      options={options}
    />
  )
}

export default RoleInput
